import { Directive } from '@angular/core';

@Directive({
  selector: '[efFormFieldPrefix]',
  standalone: true,
})
export class EfFormFieldPrefixDirective {}
